import { useEffect } from 'react';
import { useTestTransition } from './TestTransitionContext';

/**
 * TestMenu — pagina /test
 * Il background e le voci del menu sono gestiti da MenuSvgOverlay.
 * Questo componente si limita a segnalare al context di entrare in modalità "menu".
 */
export default function TestMenu() {
    const { phase, openMenu } = useTestTransition();

    useEffect(() => {
        // Apertura diretta da URL o dopo back-button
        if (phase === 'idle') {
            openMenu();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}
